import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ServicesResponse } from '../models/services.response';

@Injectable({
  providedIn: 'root',
})
export class ServicesService {
  private readonly baseUrl = environment.apiBaseUrl;
  private servicesCache$?: Observable<ServicesResponse>;
  
  constructor(private http: HttpClient) { }

  private getServices(parameter: number = -1): Observable<ServicesResponse> {
    const token = localStorage.getItem('accessToken') || '';
    const cognitoId = localStorage.getItem('cognito') || '';
    const account = localStorage.getItem('account') || '';
    const url = `${this.baseUrl}/user/${cognitoId}/services/${account}/${parameter}/commons`;   
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `${token}`,
    });
    return this.http.get<ServicesResponse>(url, { headers });
  }

  getServicesPopular(): Observable<ServicesResponse> {
    if (!this.servicesCache$) {
      this.servicesCache$ = this.getServices(-1).pipe(
        shareReplay({ bufferSize: 1, refCount: false })
      );
    }
    return this.servicesCache$;
  }

  clearCache(): void {
    this.servicesCache$ = undefined;
  }

  getServicesAll(): Observable<ServicesResponse> {
    return this.getServices(-1);
  }

  getServicesReallyPopular(): Observable<ServicesResponse> {
    return this.getServices(3);
  }
}
